export type RacingTab = "bet" | "form" | "bets";
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export function raceUuid(value: string | null | undefined): string | null {
  return value && UUID.test(value) ? value : null;
}
export function homeSelection(search: string): {
  watch: string | null;
  market: string | null;
  tab: RacingTab;
} {
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  return {
    watch: raceUuid(params.get("watch")),
    market: raceUuid(params.get("market")),
    tab: tab === "form" || tab === "bets" ? tab : "bet",
  };
}
/** Merge only display-state keys; never consume auth/native recovery parameters. */
export function homeHref(
  patch: {
    watch?: string | null;
    market?: string | null;
    tab?: RacingTab | null;
  },
  search = "",
) {
  const params = new URLSearchParams(search);
  for (const [key, value] of Object.entries(patch)) {
    if (value == null) params.delete(key);
    else params.set(key, value);
  }
  const query = params.toString();
  return `/app/${query ? `?${query}` : ""}`;
}
export function legacyRacingDestination(pathname: string, search = "") {
  const match = /^\/app\/racing(?:\/([^/]+))?\/?$/.exec(pathname);
  if (!match) return null;
  let id: string | null = null;
  try {
    id = raceUuid(match[1] ? decodeURIComponent(match[1]) : null);
  } catch {
    /* Invalid legacy link returns to live Home. */
  }
  return homeHref({ watch: id }, search);
}
